<ion-list style="max-height: 400px;overflow-y: auto;">
    @for (lang of languages; track lang) {
        <ion-item button (click)="selectLanguage(lang)">
            <ion-label>{{ lang.name }}</ion-label>
        </ion-item>
    }
  
</ion-list>